import React, { useState, useEffect } from "react";
import { useObserver } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Drawer } from "antd";
import { useStores } from "@/store";
import { Header, Loading, ListItem, Icon, Button, Locate } from "@/components";
import firebaseTrack from "@/service/firebase";
import Detail from "./components/detail";
import Appeal from "./components/appeal";
import "./index.less";
import InfiniteScroll from "react-infinite-scroller";
import { getQuery } from "@/service/http";
import EmptyBooking from "@/images/empty_bookings.svg";

let titleCache = {};
let loading = false;

/**
 * 我的预定-列表
 *
 */
const MyBookings = () => {
  const { t } = useTranslation();
  const { bookingsStore, memberStore } = useStores();
  const [visible, setVisible] = useState(false);
  const [appealVisible, setAppealVisible] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [booking, setBooking] = useState({});

  useEffect(() => {
    getBookings(1);
    firebaseTrack({ screen_name: "My bookings" });

    // 直接打开申诉弹窗
    const { reservationCode, reservationId, widget } = getQuery();
    if (reservationCode && reservationId && widget === "appeal") {
      bookingsStore
        .getBookingById(reservationCode, reservationId)
        .then((data) => {
          setBooking({
            id: data.id,
            date: data.formated_date,
          });
          setAppealVisible(true);
        });
    }
  }, []);

  /**获取预定列表 */
  async function getBookings(page) {
    try {
      if (loading) return;
      loading = true;
      let { data = [] } = await bookingsStore.getBookings({
        type: "all",
        page,
      });
      if (data.length < 10) {
        setHasMore(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      loading = false;
    }
  }

  function loadMore(page) {
    getBookings(page);
  }

  /**点击查看详情 */
  function onItemChange(item) {
    bookingsStore.currentBooking = item;
    bookingsStore.setBookingOperational(item.id)
    setVisible(true);
  }
  return useObserver(() => {
    const { bookings } = bookingsStore;
    return (
      <div className="page-bookings">
        <Locate />
        {/* <Header title={t("WEB.My bookings")} /> */}
        <Drawer
          className="booking-drawer profile-item-inner-drawer"
          placement="right"
          closable={false}
          destroyOnClose
          onClose={() => setVisible(false)}
          visible={visible}
        >
          <Header
            title={t("WEB.Booking details")}
            onClick={() => setVisible(false)}
          />
          <Detail />
        </Drawer>

        {/* 直接申诉 */}
        <Drawer
          className="booking-drawer"
          placement="right"
          closable={false}
          destroyOnClose
          onClose={() => setAppealVisible(false)}
          visible={appealVisible}
        >
          <Header
            title={t("WEB.Appeal")}
            onClick={() => setAppealVisible(false)}
          />
          <Appeal date={booking.date} id={booking.id} />
        </Drawer>

        <div className="booking-list">
          {!bookings.length?(
              <div className="booking-empty">
                <img src={EmptyBooking} alt=""/>
                <div className="txt">
                  <div>{t('BOOKING.PLACEHOLDER.TXT1')}</div>
                  <div>{t('BOOKING.PLACEHOLDER.TXT2')}</div>
                </div>
              </div>
          ):(
            <InfiniteScroll
              initialLoad={false}
              pageStart={1}
              loadMore={loadMore}
              hasMore={hasMore}
              useWindow={false}
            >
              {bookings.map((item, index) => {
                return (
                  <BookItem
                    {...item}
                    key={item.id + "_" + index}
                    onClick={() => onItemChange(item)}
                  />
                );
              })}
              <div className="load-more">
                {hasMore && <Loading red></Loading>}
              </div>
            </InfiniteScroll>
          )}
        </div>
      </div>
    );
  });
};

const BookItem = ({
  id,
  restaurant,
  formated_date,
  formated_time,
  reservation_seats,
  section_title,
  status_lng,
  status,
  onClick,
  can_review,
  review,
  point = {},
}) => {
  let { t } = useTranslation();
  let date = formated_date;
  let time = formated_time;
  const { region='shanghai',lang='en',private_token,callback,payment,login_url } = getQuery();
  /**查看餐厅详情 */
  function onRestaurantClick() {
    // window.open(restaurant.website_detail_url, "_blank");
    window.location.href = `/#/restaurants/${restaurant.id}?lang=${lang}&private_token=${private_token}&callback=${callback}&payment=${payment}&login_url=${login_url}`
    window.top.postMessage(
      {
        type: 'other',
        params: {
          url: restaurant.website_detail_url,
          region,
          lang,
        },
      },
      '*'
    )
  }
  if (!titleCache[section_title]){
    titleCache[section_title] = id;
  }
  console.log(titleCache)
  return (
    <React.Fragment>
      {/* 只展示每组第一个标题 */}
      {titleCache[section_title]===id&& <h2>{section_title}</h2>}
      <div className="book-item hairline-surround">
        {restaurant&&(
            <div
                className="book-restaurant hairline-bottom"
                onClick={onRestaurantClick}
            >
              <div className="cover">
                <img src={restaurant.cover} alt="" />
              </div>
              <div className="name">{restaurant.name}</div>
              <i className="arrow icon icon-arrow-right"></i>
            </div>
        )}
        <div className="book-detail" onClick={onClick}>
          <ListItem
            title={<Icon text={date} icon="icon icon-time" />}
            value={time}
          ></ListItem>
          <ListItem
            title={<Icon text={reservation_seats} icon="icon icon-seat" />}
            value={
              point && point.debit ? (
                <Icon
                  text={t("WEB.pointNumber", { points: point.debit })}
                  icon="icon icon-vip-grey"
                />
              ) : null
            }
          ></ListItem>
        </div>
        <footer>
          <div className="status-button" status={status}>
            {status_lng}
          </div>
          <ActionButton
            can_review={can_review}
            review={review}
            onClick={onClick}
          />
        </footer>
      </div>
    </React.Fragment>
  );
};

/**操作按钮 */
const ActionButton = ({ review, can_review, onClick }) => {
  let { t } = useTranslation();
  // if (can_review) {
  //   return (
  //     <Button type="primary" onClick={onClick}>
  //       <i className="icon icon-review"></i>
  //       {t("WEB.Review")}
  //     </Button>
  //   );
  // }
  if (review) {
    return <Icon text={t("WEB.Reviewed")} icon="icon icon-reviewed" />;
  }
  return (
    <Button type="primary" onClick={onClick}>
      <i className="icon icon-booking-white"></i>
      {t("WEB.Details")}
    </Button>
  );
};

export default MyBookings;
